export const DETAILS_STEP_ROUTE = 'szczegoly-egzaminu';
export const DETAILS_STEP_PARAMETRIZED_ROUTE = ':id/szczegoly-egzaminu';
